module.exports = __webpack_public_path__ + "img/solution_bg2.b92f656.webp";